import { Boxes } from 'lucide-react'

export function Brand() {
  return (
    <div className="flex min-w-0 items-center gap-2.5">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary text-primary-foreground">
        <Boxes className="h-[18px] w-[18px]" aria-hidden="true" />
      </div>
      <div className="min-w-0">
        <div className="text-[11px] uppercase leading-none tracking-wider text-muted">Console</div>
        <div className="truncate text-sm font-semibold text-foreground">LUDUS</div>
      </div>
    </div>
  )
}
